<template>
  <div>
    <topmenu></topmenu>

    <div class="container">
      <div class="list-con">
        <div class="left">
          <div class="nav">
            <span class="text">当前位置：首页 <span class="ico"><img src="../../assets/img/6.png" alt=""></span> {{plate}} <span v-if="plate == '心理服务'">（0396-2679926/2679936）</span></span>
          </div>
          <newslist :menuid = "menuid" :menutext= "plate"></newslist>
        </div>
        <div class="right">
          <rightnews :myProp="toChildA" :myPropType="toChildAType"></rightnews>
          <rightnews :myProp="toChildB" :myPropType="toChildBType"></rightnews>
        </div>
      </div>
    </div>
    <bottomfooter></bottomfooter>
  </div>
</template>

<script>
import topmenu from '@/views/front/components/topmenu';
import bottomfooter from '@/views/front/components/bottomfooter';
import rightnews from '@/views/front/components/rightnews';
import newslist from '@/views/front/components/newslist';

export default {
  name: 'List',
  components: {
    topmenu,
    bottomfooter,
    rightnews,
    newslist
  },
  data() {
   return {
     plate:this.$route.query.text||'搜索结果',
     menuid:this.$route.query.menuid||'',
     toChildA: '新闻动态',
     toChildB: '基层信息',
     toChildAType: '1',
     toChildBType: '3',
     keyword : ''
   };
  },
  watch:{
     '$route' (to,from){
       if(to.query.text!= from.query.text){
         this.plate = to.query.text;
       }
     }
  },
  methods: {


  }
};
</script>

<style scoped>
  .list-con{
    display: flex;
    justify-content: space-between;
  }
  .left{
    width:60%;
  }
  .right{
    width:35%;
  }
  .nav{
    background:#efefef;
    padding:10px 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/Front/List.vue